var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bin-barcode"},[_c('div',{staticClass:"bin-barcode__info"},[_c('div',{staticClass:"bin-barcode__location_code"},[_vm._v("Location code")])]),_c('div',{staticClass:"bin-barcode_img"},[_c('img',{attrs:{"src":require("@/assets/images/barcode_ex.png"),"width":"200"}})])])
}]

export { render, staticRenderFns }